<template>
  <div class="app__form">
    <template v-if="isRegistered">
      <p class="success">Registratie voltooid, check uw mailbox voor uw login-gegevens. Wij nemen zo snel mogelijk contact met u op om u wegwijs te maken binnen ons platform.</p>
      <div class="app__form__controls">
        <a class="button" href="https://v-packs.dropon.io">Log in</a>
      </div>
    </template>
    <template v-else>
      <div class="app__form__group">
        <label class="checkbox"><input type="checkbox" v-model="isCompany"> <span class="checkbox__label">Bedrijfsaccount</span></label>
      </div>
      <div class="app__form__group">
        <label for="fname">Voornaam</label>
        <input id="fname" type="text" class="input"
               :class="{'input--error':!fnameValid}"
               @input="fnameValid=true"
               v-model="customer.firstname">
      </div>
      <div class="app__form__group">
        <label for="lname">Naam</label>
        <input id="lname" type="text" class="input"
               :class="{'input--error':!lnameValid}"
               @input="lnameValid=true"
               v-model="customer.name">
      </div>
      <div class="app__form__group">
        <label for="email">E-mail</label>
        <input id="email" type="text" class="input"
               :class="{'input--error':!emailValid}"
               @input="emailValid=true"
               v-model="customer.email">
      </div>
      <div class="app__form__group">
        <label>GSM</label>
        <vue-tel-input :preferredCountries="['BE']" v-model="customer.phone"
                       placeholder="uw gsm-nummer"
                       @input="phoneInputValid=true"
                       :class="{'error':!phoneInputValid}" @validate="handlePhoneValidate"></vue-tel-input>
      </div>
      <div class="app__form__group">
        <label>Adres</label>
        <input ref="autocomplete"
               @input="addressValid=true"
               placeholder="Zoek en kies uw volledig adres"
               class="input input--address"
               :class="{'input--error':!addressValid}"
               onfocus="value = ''"
               type="text"/>
      </div>
      <div class="app__form__group">
        <label for="bus">Bus</label>
        <input id="bus" type="text" class="input input--small"
               v-model="customer.bus">
      </div>
      <template v-if="isCompany">
        <div class="app__form__group">
          <label for="name">Bedrijf</label>
          <input id="name" type="text" class="input"
                 :class="{'input--error':!companyValid}"
                 @input="companyValid=true"
                 v-model="customer.company">
        </div>
        <div class="app__form__group">
          <label for="btw">BTW nr.</label>
          <input id="btw" type="text" class="input"
                 @input="vatValid=true"
                 placeholder="BE0XXXXXXXXX"
                 :class="{'input--error':!vatValid}"
                 v-model="customer.vat">
        </div>
      </template>
      <div class="app__form__group">
        <label class="checkbox" :class="{'checkbox--error':!gdprValid && !gdprOk}"><input type="checkbox"
                                                                                          v-model="gdprOk"> <span
            class="checkbox__label">Ik heb kennis genomen van de
                    <a target="_blank" href="https://www.privalex.be/nl/bedrijven/738f2697e3"
                       title="privacy verklaring">privacy verklaring</a></span></label>
      </div>
      <div class="app__form__group">
        <label class="checkbox" :class="{'checkbox--error':!termsValid && !termsOk}"><input type="checkbox"
                                                                                            v-model="termsOk"> <span
            class="checkbox__label">Ik ga akkoord met de <router-link to="/terms" target="_blank">voorwaarden</router-link></span></label>
      </div>
      <div class="app__form__group">
        <label class="checkbox" :class="{'checkbox--error':!consentValid && !consentOk}"><input type="checkbox"
                                                                                            v-model="consentOk"> <span
            class="checkbox__label">Ik ga akkoord met de aanmelding</span></label>
      </div>
      <div class="app__form__controls">
        <button class="button" :class="{'button--disabled':isRegistering}" @click="onSubmit">Registreer</button>
      </div>
      <p v-if="registerError" class="error">Er is iets fout gelopen bij de registratie, neem contact op indien het
        probleem zich blijft voordoen.</p>
    </template>
  </div>
</template>

<script>
import {VueTelInput} from 'vue-tel-input';
import DroponService from "../services/dropon";
import VATService from "../services/vat";

export default {
  name: "Register",

  data() {
    return {
      addressComponentForm: {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        country: 'long_name',
        postal_code: 'short_name'
      },
      key: process.env.VUE_APP_GOOGLE_MAPS,
      address: {
        street_number: '',
        route: '',
        locality: '',
        country: '',
        postal_code: '',
        lat: '',
        lon: ''
      },
      gdprOk: false,
      gdprValid: true,
      termsOk: false,
      termsValid: true,
      consentOk:false,
      consentValid: true,
      phoneValid: true,
      phoneInputValid: true,
      emailValid: true,
      companyValid: true,
      fnameValid: true,
      lnameValid: true,
      addressValid: true,
      vatValid: true,
      customer: {
        DeliveryAddress: {
          street: "",
          zip: "",
          country: "",
          nr: "",
          city: ""
        },
        bus: "",
        company: "",
        email: "",
        name: "",
        firstname: "",
        phone: null,
        scanning: false,
        type: "billable",
        url: null,
        vat: ""
      },
      isRegistering: false,
      isRegistered: false,
      vatTimeout: null,
      vatError: false,
      registerError: false,
      isCompany: false
    }

  },

  mounted() {
    this.autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete, {types: ['geocode']});
    this.autocomplete.setFields(['address_components', 'geometry']);
    this.autocomplete.setComponentRestrictions({'country': ['be']});
    this.autocomplete.addListener('place_changed', this.fillAddress);
  },

  beforeDestroy() {
    clearTimeout(this.vatTimeout);
  },

  components: {
    VueTelInput
  },

  methods: {
    onSubmit() {
      this.registerError = false;
      this.resetValid();
      this.isRegistering = true;
      this.emailValid = this.mailValidate(this.customer.email);
      this.addressValid = this.address.country && this.address.street_number && this.address.locality && this.address.route && this.address.postal_code && this.address.lat && this.address.lon;
      this.phoneInputValid = this.phoneValid;
      this.companyValid = this.customer.company && this.customer.company !== "";
      this.fnameValid = this.customer.firstname && this.customer.firstname !== "";
      this.lnameValid = this.customer.name && this.customer.name !== "";
      this.gdprValid = this.gdprOk;
      this.termsValid = this.termsOk;
      this.consentValid = this.consentOk;
      if(this.isCompany) {
        this.vatValidate(this.customer.vat)
            .then(res => {
              this.vatValid = res;
              if (this.emailValid && this.addressValid && this.phoneInputValid && this.companyValid && this.fnameValid && this.lnameValid && this.gdprValid && this.termsValid && this.consentOk) {
                this.register();
                return;
              }
              this.isRegistering = false;
            })
            .catch(() => {
              this.vatValid = false;
              this.isRegistering = false;
            });
        return;
      }
      if(this.emailValid && this.addressValid && this.phoneInputValid && this.fnameValid && this.lnameValid && this.gdprValid && this.termsValid){
        this.register();
        return;
      }
      this.isRegistering = false;
    },

    resetValid() {
      this.gdprValid = true;
      this.termsValid = true;
      this.consentValid = true;
      this.emailValid = true;
      this.addressValid = true;
      this.phoneInputValid = true;
      this.fnameValid = true;
      this.lnameValid = true;
      this.vatValid = true;
    },

    vatValidate: async function (vat) {
      try {
        const res = await VATService.checkVat(vat);
        return (res.status && res.data.Valid);
      } catch {
        return false;
      }
    },

    mailValidate(email) {
      const regex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      return email.match(regex);
    },

    handlePhoneValidate(value) {
      this.phoneValid = value.valid && value.type === "mobile";
    },

    fillAddress() {
      let place = this.autocomplete.getPlace();
      this.address = {
        street_number: '',
        route: '',
        locality: '',
        country: '',
        postal_code: '',
        lat: '',
        lon: ''
      };
      this.address.lat = place.geometry.location.lat();
      this.address.lon = place.geometry.location.lng();
      for (let i = 0; i < place.address_components.length; i++) {
        let addressType = place.address_components[i].types[0];
        if (this.addressComponentForm[addressType]) {
          let val = place.address_components[i][this.addressComponentForm[addressType]];
          this.$set(this.address, addressType, val);
        }
      }
    },

    register() {
      const data = {
        delivery_address: {
          street: this.address.route,
          zip: this.address.postal_code,
          country: this.address.country,
          nr: this.address.street_number,
          city: this.address.locality,
          address: `${this.address.route} ${this.address.street_number}, ${this.address.postal_code} ${this.address.locality}, ${this.address.country}`
        },
        bus: this.customer.bus,
        company: this.isCompany? this.customer.company:`${this.customer.firstname} ${this.customer.name}`,
        email: this.customer.email,
        phone: this.customer.phone,
        geometry: {
          type: "Point",
          coordinates: [this.address.lat, this.address.lon]
        },
        vat: this.isCompany?this.customer.vat:"",
        firstname: this.customer.firstname,
        lastname: this.customer.name
      }
      DroponService.createCustomer(data).then((res) => {
        this.isRegistering = false;
        if (res) {
          this.isRegistered = true;
          return;
        }
        this.registerError = true;
      });
    }
  }
}
</script>